import React from "react";
import Navbar from "../../components/navbar/Navbar";
import ViewCustomer from "../../components/customers/ViewCustomer";

const ViewCustomerPage = () => {
  return (
    <section className="bajaj_main_block">
      <div className="container-fluid">
        {/* Navbar */}
        <div className="row">
          <div className="col-12 p-0">
            <Navbar content="VIEW CUSTOMER" />
          </div>
        </div>
        <div className="row">
          <div className="col-12 p-0">
            <ViewCustomer />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ViewCustomerPage;
